import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, FieldArray, formValueSelector } from 'redux-form';
import _ from 'lodash';
import { connect } from 'react-redux';

// Components
import { FixedTable } from 'components/content-containers/tables';
import { DateRow, ShippingTaxRow, TotalRow, SubmitRow } from './components/shared-form-components';
import LineItemRows from './components/expense-bill-line-item-rows';


function ExpenseBillForm({ cancel, handleSubmit, header, formValues, ...props }) {
  const { lineItems, shipping, tax } = formValues;
  const activeLineItems = _.reject(lineItems, (lineItem) => lineItem.status === 'Archived');
  const lineItemTotals = _.map(activeLineItems, (lineItem) => (lineItem.quantity * lineItem.unitCost) || 0);
  const total = _.sum(lineItemTotals) + Number(shipping || 0) + Number(tax || 0);

  return (
    <form onSubmit={handleSubmit} className="charges">
      <FixedTable
        className="form-table"
        invisibleHeaders={[
          'col-enter-receipt-spacing',
          'col-quantity-input',
          'col-money-input',
          'col-money-input',
          ''
        ]}
        headerRow={ header &&
          <tr className="form-header-row">
            <th colSpan="5">{header}</th>
          </tr>
        }
      >
        <tbody>
          <DateRow />
        </tbody>
        <FieldArray name="lineItems" component={LineItemRows} lineItems={lineItems} />
        <tbody>
          <ShippingTaxRow name="shipping">
            Shipping
          </ShippingTaxRow>
          <ShippingTaxRow name="tax">
            Tax
          </ShippingTaxRow>
          <TotalRow total={total}>
            Total <span className="no-emphasis remember">- Make sure this matches the credit card charge!</span>
          </TotalRow>
          <SubmitRow cancel={cancel} {...props} />
        </tbody>
      </FixedTable>
    </form>
  );
}

ExpenseBillForm.propTypes = {
  cancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  header: PropTypes.string,
  form: PropTypes.string.isRequired,
  formValues: PropTypes.object.isRequired
};


const ConnectedForm = connect((state, ownProps) => ({
  formValues: formValueSelector(ownProps.form)(state, 'lineItems', 'shipping', 'tax')
}))(ExpenseBillForm);

export default reduxForm({ validate: expenseValidation })(ConnectedForm);


// Expense validation
function expenseValidation(values) {
  const errors = {};
  const lineItemsWithQuantity = _.filter(values.lineItems, (lineItem) => Number(lineItem.quantity) > 0);
  if (!lineItemsWithQuantity.length) {
    errors.lineItems = _.map(values.lineItems, () => ({ quantity: ' ' }));
    errors._error = 'You must have at least one line item with a quantity';
  } else {
    errors.lineItems = _.map(values.lineItems, (lineItem) => {
      const lineItemErrors = {};
      if (Number(lineItem.quantity) > 0 && !lineItem.unitCost) lineItemErrors.unitCost = 'Required';
      if (Number(lineItem.quantity) > Number(lineItem.billableQuantity)) lineItemErrors.quantity = 'Too many';
      return lineItemErrors;
    });

    if (_.every(errors.lineItems, _.isEmpty)) delete errors.lineItems;
  }
  if (!values.receipt || !values.receipt.length) errors.receipt = 'Required';
  if (!values.date) errors.date = 'Required';
  return errors;
}



// WEBPACK FOOTER //
// ./app/components/models/purchases/forms/expense-bill-form.js